import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export default function CreateCharacterScrollArea({ children }: Props) {
  return (
    <div className="flex flex-col gap-2.5 -mr-5 pr-5 overflow-y-auto [scrollbar-gutter:stable] [--scrollbar-track-bg:linear-gradient(#402862,#B54876)]">
      {children}
    </div>
  );
}
